import { render, staticRenderFns } from "./Board.vue?vue&type=template&id=7c220209&scoped=true"
import script from "./Board.vue?vue&type=script&lang=ts"
export * from "./Board.vue?vue&type=script&lang=ts"
import style0 from "./Board.vue?vue&type=style&index=0&id=7c220209&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c220209",
  null
  
)

export default component.exports